import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import JsEncrypt from 'jsencrypt';
import get from '@ebay/nodash/get';
import set from '@ebay/nodash/set';
import has from '@ebay/nodash/has';
import throttle from '@ebay/nodash/throttle';
import partial from '@ebay/nodash/partial';
import partialRight from '@ebay/nodash/partialRight';
import isEqual from '@ebay/nodash/isEqual';
import cloneDeep from '@ebay/nodash/cloneDeep';
import castArray from '@ebay/nodash/castArray';
export { isEmpty,
// 判断字符串是否为空
trim,
// 删除左右两端的空格
trimAll,
// 删除全部空格
lineToHump,
// 下划线转驼峰
humpToLine,
// 驼峰转下划线
urlEncode,
// 对象转url参数, {type: 404, a: 123}转成type=404&a=123
queryStringParse,
// 把字符串?type=404?解析成{type: 404}
parseUrl,
// 解析url为{ pathname, search, hash }
matchRegexp,
// 必须命中某个正则
enum2object,
// 数组转成枚举对象
object2enum,
// 枚举对象转成数组
getFormatMaskStr,
// 脱敏处理
hasFile,
// 判断数据类型是否为文件
uniqueId,
// 生成唯一ID
loadScript,
// 加载 js 文件
rsaEncrypt,
// 加密
merge,
// 合并对象或者数组
getRawType,
// 获取数据类型
isArray,
// 判断是不是数组类型
isObject,
// 判断是不是对象类型
isString,
// 判断是不是字符串类型
isNumber,
// 判断是不是数字类型
isFunction,
// 判断是不是函数类型
checkWords,
// 敏感词校验
get, set, has, throttle, partial, partialRight, isEqual, cloneDeep, castArray };
/**
 * 判断字符串是否为空
 */
function isEmpty(str) {
  if (str === null || str === undefined || str.length === 0) {
    return true;
  }
  return false;
}
/**
 * 数据类型判断
 */
function isObject(val) {
  return getRawType(val) === 'Object';
}
function isString(val) {
  return getRawType(val) === 'String';
}
function isNumber(val) {
  return getRawType(val) === 'Number';
}
function isArray(val) {
  return getRawType(val) === 'Array';
}
function isFunction(val) {
  return getRawType(val) === 'Function';
}
/**
 * 删除左右两端的空格
 */
function trim(str) {
  return str.replace(/(^\s*)|(\s*$)/g, '');
}
/**
 * 删除全部空格
 */
function trimAll(str) {
  return str.replace(/\s/g, '');
}
/**
 * 下划线转驼峰
 */
function lineToHump(str) {
  return str.replace(/_(\w)/g, function (all, letter) {
    return letter.toUpperCase();
  });
}
/**
 * 驼峰转下划线
 */
function humpToLine(str) {
  return str.replace(/([A-Z])/g, function (all, letter) {
    return '_' + letter.toLowerCase();
  });
}
/**
 * 对象转url参数, {type: 404, a: 123}解析成type=404&a=123
 */
function urlEncode(obj) {
  var arr = [];
  for (var key in obj) {
    if (obj[key] !== undefined) arr.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key])));
  }
  return arr.join('&');
}
/**
 * 把字符串?type=404解析成{type: 404}
 */
function queryStringParse(string) {
  if (!string) return {};
  if (string[0] === '?') string = string.slice(1);
  var params = {};
  // const searchParams = new URLSearchParams(string)
  // for (const key of searchParams.keys()) {
  //   params[key] = searchParams.get(key)
  // }
  var arr = string.split('&');
  for (var i = 0; i < arr.length; i++) {
    var items = arr[i].split('=');
    params[items[0]] = items[1];
  }
  return params;
}
/**
 * 解析url为{ pathname, search, hash }
 * @param url
 */
function parseUrl(url) {
  var searchIndex = url.indexOf('?');
  var hashIndex = url.indexOf('#');
  hashIndex = ~hashIndex ? hashIndex : url.length;
  searchIndex = ~searchIndex ? searchIndex : hashIndex;
  var pathname = url.slice(0, searchIndex);
  var search = url.slice(searchIndex, hashIndex);
  var hash = url.slice(hashIndex);
  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
}
/**
 * 必须命中某个正则
 */
function matchRegexp(value, reg) {
  return isEmpty(value) || reg.test(value);
}
/**
 * 数组转成枚举对象
 */
function enum2object(enumArray) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'label';
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  if (!enumArray || enumArray.length === 0) return {};
  var mapperObject = {};
  enumArray.forEach(function (item) {
    mapperObject[item[value]] = item[label];
  });
  return mapperObject;
}
/**
 * 枚举对象转成数组
 */
function object2enum(mapObject) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'label';
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  var enumArray = [];
  for (var item in mapObject) {
    var _enumArray$push;
    enumArray.push((_enumArray$push = {}, _defineProperty(_enumArray$push, value, item), _defineProperty(_enumArray$push, label, mapObject[item]), _enumArray$push));
  }
  return enumArray;
}
/**
 * 脱敏处理
 */
function getFormatMaskStr(str) {
  var prelen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var suffixlen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var result = '';
  if (str) {
    var strlen = str.length;
    var maskStr = '****';
    if (strlen <= prelen + suffixlen) {
      result = str;
    } else {
      result = str.substring(0, prelen) + maskStr + str.substring(strlen - suffixlen);
    }
  }
  return result;
}
/**
 * 判断数据类型是否为文件(只判断一层, 如果层级很深，form-data 也不好表达)
 */
function hasFile(object) {
  return Object.keys(object).some(function (key) {
    var value = object[key];
    return value instanceof File || Array.isArray(value) && value.length && value[0] instanceof File;
  });
}
/**
 * 生成唯一ID
 */
var idCounter = {};
function uniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '$lodash$';
  if (!idCounter[prefix]) {
    idCounter[prefix] = 0;
  }
  var id = ++idCounter[prefix];
  if (prefix === '$lodash$') {
    return "".concat(id);
  }
  return "".concat(prefix).concat(id);
}
/**
 * 加载 js 文件
 */
function loadScript(src) {
  return new Promise(function (ok, fail) {
    var script = document.createElement('script');
    script.onerror = function (reason) {
      return fail(reason);
    };
    if (~src.indexOf('{{callback}}')) {
      var callbackFn = uniqueId('loadscriptcallback_');
      window[callbackFn] = function () {
        ok();
        delete window[callbackFn];
      };
      src = src.replace('{{callback}}', callbackFn);
    } else {
      script.onload = function () {
        return ok();
      };
    }
    script.src = src;
    document.head.appendChild(script);
  });
}
/**
 * 加密
 */
function rsaEncrypt(plainText, rsa) {
  var encrypt = new JsEncrypt();
  encrypt.setPublicKey(rsa);
  return encrypt.encrypt(plainText);
}
/**
 * 获取数据类型
 */
function getRawType(val) {
  return Object.prototype.toString.call(val).slice(8, -1);
}
/**
 * merge 合并对象属性
 */
function merge(source, other) {
  if (!isObject(source) || !isObject(other)) {
    return other === undefined ? source : other;
  }
  // 合并两个对象的 key
  return Object.keys(_objectSpread(_objectSpread({}, source), other)).reduce(function (acc, key) {
    // 递归合并 value
    // acc[key] = merge(source[key], other[key])
    acc[key] = merge(source[key], other[key]);
    return acc;
  }, Array.isArray(source) ? [] : {});
}
/**
 * 敏感词校验
 * value 需要检测的字符产
 * words 新传入的敏感词
 * isMerge 是否合并新传入的敏感词
 */
function checkWords(value, words) {
  var isMerge = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var defaultWords = '博彩|赌博|dubo|bocai|金沙|加微|会员|汇源|充值|花费|法轮';
  var newWords = '';
  if (isMerge && words) {
    newWords = defaultWords + '|' + words;
  } else if (words && !isMerge) {
    newWords = words;
  } else {
    newWords = defaultWords;
  }
  var pattern = new RegExp("(".concat(newWords, ")"));
  var match = pattern.exec(value);
  if (match) {
    return true;
  }
  return false;
}